class CountNum {

  constructor() {
    this.numCounter()
  }

  async numCounter() {
    let num = document.querySelectorAll('.ns__box--num p');

    const options = {
      rootMargin: '0px',
      threshold: 0.2
    };

    num.forEach((n) => {
      let curNum = parseInt(n.innerHTML);
      let count = 0
      n.innerHTML = count.toString();

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.intersectionRatio > 0) {
            
            let timer = setInterval(function () {
              n.innerHTML = count < 10 ? `0${count.toString()}` : count.toString()
      
              if (count === curNum) { // stop condition
                clearInterval(timer);
              }
          
              count++;
            }, 80);

            observer.unobserve(entry.target);
          }
          return;
        });
      }, options);

      const element = document.querySelector('.ns__box--num p')
      observer.observe(element);
      })

  }
    
}

new CountNum;